/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdWebFeaturesStoreStoreDataResponseStoreMetaFromJSON, FxIdWebFeaturesStoreStoreDataResponseStoreMetaToJSON, } from './FxIdWebFeaturesStoreStoreDataResponseStoreMeta';
import { FxIdWebFeaturesStoreStoreDataResponseProductWithPriceFromJSON, FxIdWebFeaturesStoreStoreDataResponseProductWithPriceToJSON, } from './FxIdWebFeaturesStoreStoreDataResponseProductWithPrice';
/**
 * Check if a given object implements the FxIdWebFeaturesStoreStoreDataResponse interface.
 */
export function instanceOfFxIdWebFeaturesStoreStoreDataResponse(value) {
    if (!('Products' in value) || value['Products'] === undefined)
        return false;
    if (!('Meta' in value) || value['Meta'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesStoreStoreDataResponseFromJSON(json) {
    return FxIdWebFeaturesStoreStoreDataResponseFromJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreStoreDataResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Products': (json['Products'].map(FxIdWebFeaturesStoreStoreDataResponseProductWithPriceFromJSON)),
        'Meta': FxIdWebFeaturesStoreStoreDataResponseStoreMetaFromJSON(json['Meta']),
    };
}
export function FxIdWebFeaturesStoreStoreDataResponseToJSON(json) {
    return FxIdWebFeaturesStoreStoreDataResponseToJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreStoreDataResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Products': (value['Products'].map(FxIdWebFeaturesStoreStoreDataResponseProductWithPriceToJSON)),
        'Meta': FxIdWebFeaturesStoreStoreDataResponseStoreMetaToJSON(value['Meta']),
    };
}
//# sourceMappingURL=FxIdWebFeaturesStoreStoreDataResponse.js.map